import { topazSetupService } from '@afterpaytouch/topaz-api/setup'

export const {
  useSetupOrderMutation,
  useSetupPaymentMutation,
  endpoints: { setupPayment },
} = topazSetupService
